import { render, staticRenderFns } from "./PartitionItem.vue?vue&type=template&id=d2e16864"
import script from "./PartitionItem.vue?vue&type=script&lang=js"
export * from "./PartitionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports